var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"pa-3"},[_c('TopBar'),_c('Basic'),_c('Tiers')],1)}
var staticRenderFns = []

export { render, staticRenderFns }